/**
 * Shared animation constants for the Create Version flow.
 * Mirrors the patterns established in InterviewChatPage.
 */

export const messageVariantsLeft = {
  initial: { opacity: 0, y: 16, x: -12 },
  animate: { opacity: 1, y: 0, x: 0 },
};

export const messageVariantsRight = {
  initial: { opacity: 0, y: 16, x: 12 },
  animate: { opacity: 1, y: 0, x: 0 },
};

export const easeOut = { duration: 0.5, ease: [0.16, 1, 0.3, 1] as const };

export const chipContainerVariants = {
  initial: {},
  animate: { transition: { staggerChildren: 0.08, delayChildren: 0.1 } },
};

export const chipVariants = {
  initial: { opacity: 0, y: 8, scale: 0.95 },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { type: 'spring' as const, stiffness: 300, damping: 24 },
  },
};

export const cardContainerVariants = {
  initial: {},
  animate: { transition: { staggerChildren: 0.1, delayChildren: 0.05 } },
};
